@let mobile = isMobile() ? '-mobile' : '';
<ng-container>
  <div class="card">
    <div class="filters-title-container">
      <h2 class="filters-title">{{ searchFilterTranslations().textFilters }}</h2>
      @if (isInServiceVehiclesEnabled) {
        <app-vehicle-type-select
          (vehicleTypeSelection)="selectVehicleType($event)"
          [filterByIsv]="filterByIsv$()">
        </app-vehicle-type-select>
      }
      <div class="form-group">
        @if (isSoldInventoryFeatureEnabled) {
          <div class="custom-control custom-radio mb-3 mt-3">
            <input
              class="custom-control-input"
              id="status-filter-active"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Active"
              [checked]="isStatusFilterChecked(statusFilters.ACTIVE_VEHICLES)"
              (click)="setStatusFilter(statusFilters.ACTIVE_VEHICLES)"
              aria-labelledby="status-filter-active__label"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.ACTIVE_VEHICLES)"
            />
            <label id="status-filter-active__label" class="custom-control-label ms-2"
                   for="status-filter-active"
            >{{ searchFilterTranslations().textActiveVehicles }}</label
            >
          </div>
        }
        @if (isReservedFilterEnabled && this.filterByIsv$()) {
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="status-filter-reserved"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Reserved"
              [checked]="isStatusFilterChecked(statusFilters.RESERVED_VEHICLES)"
              (click)="setStatusFilter(statusFilters.RESERVED_VEHICLES)"
              aria-labelledby="status-filter-reserved__label"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.RESERVED_VEHICLES)"
            />
            <label class="custom-control-label ms-2" for="status-filter-reserved"
            >{{ searchFilterTranslations().textReservedVehicles }}</label
            >
          </div>
        }
        @if (isSoldInventoryFeatureEnabled) {
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="status-filter-sold"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Sold"
              [checked]="isStatusFilterChecked(statusFilters.SOLD_VEHICLES)"
              (click)="setStatusFilter(statusFilters.SOLD_VEHICLES)"
              aria-labelledby="status-filter-sold__label"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.SOLD_VEHICLES)"
            />
            <label id="status-filter-sold__label" class="custom-control-label ms-2"
                   for="status-filter-sold"
            >{{ searchFilterTranslations().textSoldVehicles }}</label
            >
          </div>
        }
        @if (isSharedVehicleFilterEnabled) {
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="status-filter-shared"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              [attr.data-track-name]="analyticsRadioOption"
              [checked]="isStatusFilterChecked(statusFilters.SHARED_VEHICLES)"
              (click)="setStatusFilter(statusFilters.SHARED_VEHICLES)"
              aria-labelledby="status-filter-shared"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.SHARED_VEHICLES)"
            />
            <label id="status-filter-shared__label" class="custom-control-label ms-2"
                   for="status-filter-shared"
            >{{ searchFilterTranslations().textSharedVehicles }}</label
            >
          </div>
        }
        @if (isSellHoldFilterEnabled && !this.filterByIsv$()
        || isSellUpdateInventoryFeatureEnabled) {
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="status-filter-hold"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Hold"
              [checked]="isStatusFilterChecked(statusFilters.HOLD_VEHICLES)"
              (click)="setStatusFilter(statusFilters.HOLD_VEHICLES)"
              aria-labelledby="status-filter-hold__label"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.HOLD_VEHICLES)"
            />
            <label id="status-filter-hold__label" class="custom-control-label ms-2"
                   for="status-filter-hold"
            >{{ searchFilterTranslations().textHoldVehicles }}</label
            >
          </div>
        }
        @if (isSellRemovedFilterEnabled || isSellUpdateInventoryFeatureEnabled) {
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="status-filter-removed"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Removed"
              [checked]="isStatusFilterChecked(statusFilters.REMOVED_VEHICLES)"
              (click)="setStatusFilter(statusFilters.REMOVED_VEHICLES)"
              aria-labelledby="status-filter-removed__label"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.REMOVED_VEHICLES)"
            />
            <label class="custom-control-label ms-2" for="status-filter-removed"
            >{{ searchFilterTranslations().textRemovedVehicles }}</label
            >
          </div>
        }
        @if (isSellAllFilterEnabled || isSellUpdateInventoryFeatureEnabled) {
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="status-filter-all"
              type="radio"
              [name]="isMobile() ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="All"
              [checked]="isStatusFilterChecked(statusFilters.ALL_VEHICLES)"
              (click)="setStatusFilter(statusFilters.ALL_VEHICLES)"
              aria-labelledby="status-filter-all_label"
              [attr.aria-checked]="isStatusFilterChecked(statusFilters.ALL_VEHICLES)"
            />
            <label id="status-filter-all__label" class="custom-control-label ms-2"
                   for="status-filter-all"
            >{{ searchFilterTranslations().textAllVehicles }}</label
            >
          </div>
        }
      </div>
      @if (showTenantFilter) {
        <app-radio-button-group
          [label]="searchFilterTranslations().labelTenant"
          [radioButtonGroup]="tenantList$()"
          (subfilterSelection)="setTenantFilter($event)"
        >
        </app-radio-button-group>
      }

      @if (isActiveVehiclesFilterSelected && showBidLeftRailFilters) {
        <app-bids-filter
          (bidFilterSelection)="setBidFilter($event)"
        ></app-bids-filter>
      }
      @if (isRemovalFilterHideShow && showRemovalTypeLeftRailFilters) {
        <div>
          <h2 class="filters-title">{{ searchFilterTranslations().textRemovalType }} </h2>
          <div class="form-group">
            <div class="custom-control custom-radio mb-3 mt-3">
              <input
                class="custom-control-input radio-remove-type"
                id="remove-filter-active"
                type="radio"
                [name]="remove-filter"
                data-track-elem="radio"
                data-track-trigger="filter"
                data-track-name="Removed"
                [checked]="isRepostedFilterChecked(repostedFilters.ALL)"
                (click)="setRepostedFilter(repostedFilters.ALL)"
                aria-labelledby="status-filter-removed__label"
                [attr.aria-checked]="isRepostedFilterChecked(repostedFilters.ALL)"
              />
              <label id="status-filter-removed__label" class="custom-control-label ms-2"
                     for="remove-filter-active">{{ searchFilterTranslations().textAll }}</label>
            </div>
            <div class="custom-control custom-radio mb-3 mt-3">
              <input class="custom-control-input radio-remove-type"
                     id="remove-filter-not_reposted"
                     type="radio"
                     [name]="remove-filter"
                     data-track-elem="radio"
                     data-track-trigger="filter"
                     data-track-name="Not_Reposted"
                     [checked]="isRepostedFilterChecked(repostedFilters.NOT_REPOSTED)"
                     (click)="setRepostedFilter(repostedFilters.NOT_REPOSTED)"
                     aria-labelledby="status-filter-not_reposted__label"
                     [attr.aria-checked]="isRepostedFilterChecked(repostedFilters.NOT_REPOSTED)"
              />
              <label id="status-filter-not_reposted__label" class="custom-control-label ms-2"
                     for="remove-filter-not_reposted">{{ searchFilterTranslations().labelNotReposted }}</label>
            </div>
            <div class="custom-control custom-radio mb-3 mt-3">
              <input class="custom-control-input radio-remove-type"
                     id="remove-filter-reposted" type="radio"
                     [name]="remove-filter"
                     data-track-elem="radio"
                     data-track-trigger="filter"
                     data-track-name="Reposted"
                     [checked]="isRepostedFilterChecked(repostedFilters.REPOSTED)"
                     (click)="setRepostedFilter(repostedFilters.REPOSTED)"
                     aria-labelledby="status-filter-reposted__label"
                     [attr.aria-checked]="isRepostedFilterChecked(repostedFilters.REPOSTED)"
              />
              <label id="status-filter-reposted__label" class="custom-control-label ms-2"
                     for="remove-filter-reposted">{{ searchFilterTranslations().labelReposted }}</label>
            </div>
          </div>
        </div>
      }

      @if (isRemoveVehiclesFilterSelected || isSoldVehiclesFilterSelected) {
        <div>
          @if (isSellReservationFiltersEnabled && filterByIsv$()) {
            <div
              class="sell-filter-section-header sold-filter-title fw-bold">{{ searchFilterTranslations().labelSoldDate }}
            </div>
          }
          <app-date-range
            [trackCalendars]="true"
            class="ms-auto pt-2 mobile-datepicker vertical-date-range"
          >
          </app-date-range>
        </div>
      }
    </div>

    @if (isSharedVehiclesFilterSelected) {
      <app-search-filter-section
        title="{{ getSharedVehiclesSectionTitle }}"
        [open]="getOpenFilterSection === filterSectionTypes.SHARED_LISTS"
        (openChange)="setSearchFilterSection(filterSectionTypes.SHARED_LISTS)"
      >
        @if (!isAccountManagerFilterEnabled) {
          <app-shared-vehicles-filter></app-shared-vehicles-filter>
        } @else {
          <app-account-manager-shared-vehicles-filter></app-account-manager-shared-vehicles-filter>
        }
      </app-search-filter-section>
    }

    @if (showOffersLeftRailFilters) {
      @if (isActiveVehiclesFilterSelected) {
        <app-search-filter-section
          title="{{ searchFilterTranslations().titleOffers }}"
          [open]="getOpenFilterSection === filterSectionTypes.OFFERS"
          (openChange)="setSearchFilterSection(filterSectionTypes.OFFERS)"
        >
          <div class="form-group">
            <div class="custom-control custom-radio mb-3">
              <input
                class="custom-control-input"
                id="offer-filter-none"
                type="radio"
                [name]="isMobile() ? 'offer-filter-mobile' : 'offer-filter'"
                data-track-elem="radio"
                data-track-trigger="filter"
                data-track-name="Don't filter by Offers"
                [checked]="isDealerFilterChecked(offerFilters.NONE)"
                (click)="setDealerFilter(offerFilters.NONE)"
                aria-labelledby="offer-filter-none__label"
              />
              <label id="offer-filter-none__label" class="custom-control-label ms-2"
                     for="offer-filter-none"
              >{{ searchFilterTranslations().labelDontFilter }}</label
              >
            </div>
            <div class="custom-control custom-radio mb-3">
              <input
                class="custom-control-input"
                id="offer-filter-only-offers"
                [name]="isMobile() ? 'offer-filter-mobile' : 'offer-filter'"
                type="radio"
                data-track-elem="radio"
                data-track-trigger="filter"
                data-track-name="Show all vehicles with Offers"
                [checked]="isDealerFilterChecked(offerFilters.OFFERS_BY_ANY_DEALER)"
                (click)="setDealerFilter(offerFilters.OFFERS_BY_ANY_DEALER)"
                aria-labelledby="offer-filter-only-offers__label"
              />
              <label id="offer-filter-only-offers__label" class="custom-control-label ms-2"
                     for="offer-filter-only-offers"
              >{{ searchFilterTranslations().labelOutstandingOffers }}</label
              >
            </div>
            <div class="ms-2 mb-3">
              @if (isDealerFilterChecked(offerFilters.OFFERS_BY_ANY_DEALER)
              && isAccountManagerFilterEnabled) {
                <app-account-manager-dealer-filter
                  [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.OFFERS"
                ></app-account-manager-dealer-filter>
              }
            </div>
            @if (isSellerCounteredFilterEnabled) {
              <div class="custom-control custom-radio mb-3">
                <input
                  class="custom-control-input"
                  [attr.id]="'seller-counter-offer-filter' + mobile"
                  [name]="'seller-counter-offer-filter' + mobile"
                  type="radio"
                  data-track-elem="radio"
                  data-track-trigger="filter"
                  data-track-name="Show all vehicles with seller countered offers"
                  [checked]="isDealerFilterChecked(offerFilters.DEALERS_WITH_COUNTER_OFFERS)"
                  (click)="setDealerFilter(offerFilters.DEALERS_WITH_COUNTER_OFFERS)"
                  [attr.aria-labelledby]="'seller-counter-offer-filter' + mobile + '__label'"
                />
                <label [attr.id]="'seller-counter-offer-filter__label' + mobile + '__label'"
                       class="custom-control-label ms-2"
                       [attr.for]="'seller-counter-offer-filter' + mobile"
                >{{ searchFilterTranslations().labelSellerCountered }}</label
                >
              </div>
              @if (isDealerFilterChecked(offerFilters.DEALERS_WITH_COUNTER_OFFERS)) {
                @if (isAccountManagerFilterEnabled) {
                  <div class="ms-2">
                    <app-account-manager-dealer-filter
                      [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.OFFERS"
                    ></app-account-manager-dealer-filter>
                  </div>
                } @else {
                  <div class="mb-2">
                    <app-dealer-filter
                      [searchBoxDisabled]="false"
                      [dealerList]="sellerCounterOffersDealerList$()"
                      [dealerFilter]="offerFilters.DEALERS_WITH_COUNTER_OFFERS"
                      [btnShowMore]="searchFilterTranslations().labelShowMore"
                    ></app-dealer-filter>
                  </div>
                }
              }
            }
            @if (isShowBuyingDealershipName) {
              <div class="custom-control custom-radio mb-3">
                <input
                  class="custom-control-input"
                  id="offer-filter-by-dealer"
                  [name]="isMobile() ? 'offer-filter-mobile' : 'offer-filter'"
                  type="radio"
                  data-track-elem="radio"
                  data-track-trigger="filter"
                  data-track-name="Show Offers made by selected dealers"
                  [checked]="isDealerFilterChecked(offerFilters.OFFERS_BY_DEALER)"
                  (click)="setDealerFilter(offerFilters.OFFERS_BY_DEALER)"
                  aria-labelledby="offer-filter-by-dealer__label"
                />
                <label id="offer-filter-by-dealer__label" class="custom-control-label ms-2"
                       for="offer-filter-by-dealer"
                >{{ searchFilterTranslations().labelAllOffer }}</label
                >
              </div>
            }
          </div>
          @if (getOpenFilterSection === filterSectionTypes.OFFERS && isDealerFilterChecked(
            offerFilters.OFFERS_BY_DEALER)) {
            @if (isAccountManagerFilterEnabled) {
              <div class="ms-2">
                <app-account-manager-dealer-filter
                  [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.OFFERS"
                ></app-account-manager-dealer-filter>
              </div>
            } @else {
              <div class="mb-2">
                <app-dealer-filter
                  [searchBoxDisabled]="true"
                  [dealerList]="offersDealerList"
                  [dealerFilter]="offerFilters.OFFERS_BY_DEALER"
                  [btnShowMore]="showAllDealersText$()"
                ></app-dealer-filter>
              </div>
            }
          }
        </app-search-filter-section>
      }
    }


    @if (isSharedVehiclesFilterSelected && !this.filterByIsv$()) {
      <app-search-filter-section
        title="{{ searchFilterTranslations().titleOffers }}"
        [open]="getOpenFilterSection === filterSectionTypes.OFFERS"
        (openChange)="setSearchFilterSection(filterSectionTypes.OFFERS)"
      >
        <div class="form-group">
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="offer-filter-none"
              type="radio"
              [name]="isMobile() ? 'offer-filter-mobile' : 'offer-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Don't filter by Offers"
              [checked]="isDealerFilterChecked(offerFilters.NONE)"
              (click)="setDealerFilter(offerFilters.NONE)"
              aria-labelledby="offer-filter-none__label"
            />
            <label id="offer-filter-none__label" class="custom-control-label ms-2"
                   for="offer-filter-none"
            >{{ searchFilterTranslations().labelDontFilter }}</label
            >
          </div>
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="offer-filter-only-offers"
              [name]="isMobile() ? 'offer-filter-mobile' : 'offer-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Show all vehicles with Offers"
              [checked]="isDealerFilterChecked(offerFilters.OFFERS_BY_ANY_DEALER)"
              (click)="setDealerFilter(offerFilters.OFFERS_BY_ANY_DEALER)"
              aria-labelledby="offer-filter-only-offers__label"
            />
            <label id="offer-filter-only-offers__label" class="custom-control-label ms-2"
                   for="offer-filter-only-offers"
            >{{ searchFilterTranslations().labelOutstandingOffers }}</label
            >
          </div>
          <div class="ms-2 mb-3">
            @if (isDealerFilterChecked(offerFilters.OFFERS_BY_ANY_DEALER)
            && isAccountManagerFilterEnabled) {
              <app-account-manager-dealer-filter
                [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.OFFER_LISTS"
              ></app-account-manager-dealer-filter>
            }
          </div>
          @if (isSellerCounteredFilterEnabled) {
            <div class="custom-control custom-radio mb-3">
              <input
                class="custom-control-input"
                [attr.id]="'shared-seller-counter-offer-filter' + mobile"
                [name]="'shared-seller-counter-offer-filter' + mobile"
                type="radio"
                data-track-elem="radio"
                data-track-trigger="filter"
                data-track-name="Show all shared list vehicles with seller countered offers"
                [checked]="isDealerFilterChecked(offerFilters.DEALERS_WITH_COUNTER_OFFERS)"
                (click)="setDealerFilter(offerFilters.DEALERS_WITH_COUNTER_OFFERS)"
                [attr.aria-labelledby]="'shared-seller-counter-offer-filter' + mobile + '__label'"
              />
              <label [attr.id]="'shared-seller-counter-offer-filter' + mobile + '__label'"
                     class="custom-control-label ms-2"
                     [attr.for]="'shared-seller-counter-offer-filter' + mobile"
              >{{ searchFilterTranslations().labelSellerCountered }}</label
              >
            </div>
            @if (isDealerFilterChecked(offerFilters.DEALERS_WITH_COUNTER_OFFERS)) {
              @if (isAccountManagerFilterEnabled) {
                <div class="ms-2">
                  <app-account-manager-dealer-filter
                    [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.OFFER_LISTS"
                  ></app-account-manager-dealer-filter>
                </div>
              } @else {
                <div class="mb-2">
                  <app-dealer-filter
                    [searchBoxDisabled]="false"
                    [dealerList]="sellerCounterOffersDealerList$()"
                    [dealerFilter]="offerFilters.DEALERS_WITH_COUNTER_OFFERS"
                    [btnShowMore]="searchFilterTranslations().labelShowMore"
                  ></app-dealer-filter>
                </div>
              }
            }
          }
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="offer-filter-by-dealer"
              [name]="isMobile() ? 'offer-filter-mobile' : 'offer-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Selling Dealer Name"
              [checked]="isDealerFilterChecked(offerFilters.OFFERS_BY_DEALER)"
              (click)="setDealerFilter(offerFilters.OFFERS_BY_DEALER)"
              aria-labelledby="offer-filter-by-dealer__label"
            />
            <label id="offer-filter-by-dealer__label" class="custom-control-label ms-2"
                   for="offer-filter-by-dealer"
            >{{ searchFilterTranslations().labelAllOffersTo + sellerDealerName$() }}</label
            >
          </div>
        </div>
        @if ((getOpenFilterSection === filterSectionTypes.OFFERS && isDealerFilterChecked(
          offerFilters.OFFERS_BY_DEALER))) {
          @if (isAccountManagerFilterEnabled) {
            <div class="ms-2">
              <app-account-manager-dealer-filter
                [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.OFFER_LISTS"
              ></app-account-manager-dealer-filter>
            </div>
          } @else {
            <div class="form-group">
              @if (offerListCreators) {
                <div class="control-wrapper">
                  <ul>
                    @if (offerListCreators?.length > 1) {
                      <li class="custom-control custom-checkbox">
                        <input
                          class="custom-control-input"
                          id="offer-option-1"
                          type="checkbox"
                          data-track-elem="checkbox"
                          data-track-trigger="filter"
                          data-track-name="Select All"
                          (change)="isSelectAllChecked(offerFilters.OFFERS_BY_DEALER)"
                          [checked]="toggleSelectAll(offerFilters.OFFERS_BY_DEALER)"
                          #selectAllUsers
                          aria-labelledby="offer-option-1__label"
                        />
                        <label id="offer-option-1__label" class="custom-control-label ms-2"
                               for="offer-option-1">{{ searchFilterTranslations().labelSelectAll }}</label>
                      </li>
                    }
                    <!-- Show 10 or all sellers -->
                    @for (user of offerListCreators | slice: 0:(isShowAll(
                      offerFilters.OFFERS_BY_DEALER) ? offerListCreators.length
                      : 9); track dealerById($index, user)) {
                      <li
                        class="custom-control custom-checkbox"
                      >
                        <input
                          class="custom-control-input"
                          [attr.id]="'user-offers-' + user.value"
                          type="checkbox"
                          [checked]="isDealerSelected(offerFilters.OFFERS_BY_DEALER, user.value)"
                          data-track-elem="checkbox"
                          data-track-trigger="filter"
                          [value]="user.value"
                          (change)="toggleDealer(offerFilters.OFFERS_BY_DEALER, user.value)"
                        />
                        <label
                          [attr.id]="'user-offers-' + user.value + '__label'"
                          class="custom-control-label ms-2"
                          [attr.for]="'user-offers-' + user.value"
                        >{{ user.name }}</label
                        >
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
            @if (offerListCreators.length > 9) {
              <div>
                <button
                  data-track-elem="button"
                  [attr.data-track-name]="showAllDealersText$()"
                  class="btn-link text-primary fw-bold"
                  type="button"
                  (click)="toggleShowAll(offerFilters.OFFERS_BY_DEALER)"
                >
                  {{ showAllOfferListCreatorsText$() }}
                </button>
              </div>
            }
          }
        }
      </app-search-filter-section>
    }


    @if (showQuestionsLeftRailFilters) {
      @if (isActiveVehiclesFilterSelected) {
        <app-search-filter-section
          title="{{ searchFilterTranslations().titleQuestions }}"
          [open]="getOpenFilterSection === filterSectionTypes.QUESTIONS"
          (openChange)="setSearchFilterSection(filterSectionTypes.QUESTIONS)"
        >
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="question-filter-none"
              [name]="isMobile() ? 'question-filter-mobile' : 'question-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Don't filter by Questions"
              [checked]="isDealerFilterChecked(questionFilters.NONE)"
              (click)="setDealerFilter(questionFilters.NONE)"
              aria-labelledby="question-filter-none__label"
            />
            <label id="question-filter-none__label" class="custom-control-label ms-2"
                   for="question-filter-none"
            >{{ searchFilterTranslations().labelDontQuestion }}</label
            >
          </div>
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="question-filter-only-questions"
              [name]="isMobile() ? 'question-filter-mobile' : 'question-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Show all vehicles with Questions"
              [checked]="isDealerFilterChecked(questionFilters.QUESTIONS_BY_ANY_DEALER)"
              (click)="setDealerFilter(questionFilters.QUESTIONS_BY_ANY_DEALER)"
              aria-labelledby="question-filter-only-questions__label"
            />
            <label
              id="question-filter-only-questions__label"
              class="custom-control-label ms-2"
              for="question-filter-only-questions"
            >{{ searchFilterTranslations().labelOutstandingQuestions }}</label
            >
          </div>
          @if (isShowBuyingDealershipName) {
            <div class="custom-control custom-radio mb-3">
              <input
                class="custom-control-input"
                id="question-filter-by-dealer"
                [name]="isMobile() ? 'question-filter-mobile' : 'question-filter'"
                allytmln="Selling Dealer Name"
                type="radio"
                data-track-elem="radio"
                data-track-trigger="filter"
                data-track-name="Selling Dealer Name"
                [checked]="isDealerFilterChecked(questionFilters.QUESTIONS_BY_DEALER)"
                (click)="setDealerFilter(questionFilters.QUESTIONS_BY_DEALER)"
                aria-labelledby="question-filter-by-dealer__label"
              />
              <label id="question-filter-by-dealer__label" class="custom-control-label ms-2"
                     for="question-filter-by-dealer"
              >{{ searchFilterTranslations().labelAllQuestion }}</label
              >
            </div>
            @if (isDealerFilterChecked(questionFilters.QUESTIONS_BY_DEALER)) {
              <div class="mb-2">
                <app-dealer-filter
                  [searchBoxDisabled]="true"
                  [dealerList]="questionsDealerList"
                  [dealerFilter]="questionFilters.QUESTIONS_BY_DEALER"
                  [btnShowMore]="showAllQuestionsText$()"
                ></app-dealer-filter>
              </div>
            }
          }
        </app-search-filter-section>
      }
    }

    @if (showSoldBidsOffersLeftRailFilters) {
      @if (isSoldVehiclesFilterSelected) {
        <app-search-filter-section
          title="{{ searchFilterTranslations().titleBidsOffers }}"
          [open]="getOpenFilterSection === filterSectionTypes.BIDS_OFFERS"
          (openChange)="setSearchFilterSection(filterSectionTypes.BIDS_OFFERS)"
        >
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="bid-offer-filter-none"
              [name]="isMobile() ? 'bid-offer-filter-mobile' : 'bid-offer-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Show all"
              [checked]="isDealerFilterChecked(bidsOffersFilters.ALL)"
              (change)="setDealerFilter(bidsOffersFilters.ALL)"
              aria-labelledby="bid-offer-filter-none__label"
            />
            <label id="bid-offer-filter-none__label" class="custom-control-label ms-2"
                   for="bid-offer-filter-none"
            >{{ searchFilterTranslations().labelShowAll }}</label
            >
          </div>
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="winning-bid-offer-dealers"
              [name]="isMobile() ? 'bid-offer-filter-mobile' : 'bid-offer-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Winning bids/offers"
              [checked]="isDealerFilterChecked(bidsOffersFilters.WINNING_BIDS_OFFERS)"
              (change)="setDealerFilter(bidsOffersFilters.WINNING_BIDS_OFFERS)"
              aria-labelledby="winning-bid-offer-dealers__label"
            />
            <label id="winning-bid-offer-dealers__label" class="custom-control-label ms-2"
                   for="winning-bid-offer-dealers"
            >{{ searchFilterTranslations().labelWinningBidsOffers }}</label
            >
          </div>
          @if (isDealerFilterChecked(bidsOffersFilters.WINNING_BIDS_OFFERS)) {
            @if (isAccountManagerFilterEnabled) {
              <div class="ms-2">
                <app-account-manager-dealer-filter
                  [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.WINNING_BIDS_OFFERS"
                ></app-account-manager-dealer-filter>
              </div>
            } @else {
              <div class="mb-2">
                <app-dealer-filter
                  [dealerList]="winningBidsOffersDealerList"
                  [dealerFilter]="bidsOffersFilters.WINNING_BIDS_OFFERS"
                  [btnShowMore]="searchFilterTranslations().labelShowMore"
                ></app-dealer-filter>
              </div>
            }
          }
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="bids-offers-by-dealer"
              [name]="isMobile() ? 'bid-offer-filter-mobile' : 'bid-offer-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Losing bids/offers"
              [checked]="isDealerFilterChecked(bidsOffersFilters.LOSING_BIDS_OFFERS)"
              (change)="setDealerFilter(bidsOffersFilters.LOSING_BIDS_OFFERS)"
              aria-labelledby="bids-offers-by-dealer__label"
            />
            <label id="bids-offers-by-dealer__label" class="custom-control-label ms-2"
                   for="bids-offers-by-dealer"
            >{{ searchFilterTranslations().labelLosingBidsOffers }}</label
            >
          </div>
          @if (isDealerFilterChecked(bidsOffersFilters.LOSING_BIDS_OFFERS)) {
            @if (isAccountManagerFilterEnabled) {
              <div class="ms-2">
                <app-account-manager-dealer-filter
                  [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.LOSING_BIDS_OFFERS"
                ></app-account-manager-dealer-filter>
              </div>
            } @else {
              <div class="mb-2">
                <app-dealer-filter
                  [dealerList]="losingBidsOffersDealerList"
                  [dealerFilter]="bidsOffersFilters.LOSING_BIDS_OFFERS"
                  [btnShowMore]="searchFilterTranslations().labelShowMore"
                ></app-dealer-filter>
              </div>
            }
          }
        </app-search-filter-section>
      }
    }

    @if (isGroundingStatusFilterHideShow) {
      <app-search-filter-section
        title="{{ searchFilterTranslations().titleGroundingStatus }}"
        [open]="getOpenFilterSection === filterSectionTypes.GROUNDED"
        (openChange)="setSearchFilterSection(filterSectionTypes.GROUNDED)"
      >
        <div class="form-group">
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="grounded-filter-all"
              type="radio"
              [name]="isMobile() ? 'grounded-filter-mobile' : 'grounded-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="All"
              [checked]="isGroundedFilterChecked(groundedFilters.ALL)"
              (change)="setGroundedFilter(groundedFilters.ALL)"
              aria-labelledby="grounded-filter-all__label"
              [attr.aria-checked]="isGroundedFilterChecked(groundedFilters.ALL)"
            />
            <label id="grounded-filter-all__label" class="custom-control-label ms-2"
                   for="grounded-filter-all"
            >{{ searchFilterTranslations().textAll }}</label
            >
          </div>
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="grounded-filter"
              [name]="isMobile() ? 'grounded-filter-mobile' : 'grounded-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Grounded"
              [checked]="isGroundedFilterChecked(groundedFilters.GROUNDED)"
              (change)="setGroundedFilter(groundedFilters.GROUNDED)"
              aria-labelledby="grounded-filter__label"
              [attr.aria-checked]="isGroundedFilterChecked(groundedFilters.GROUNDED)"
            />
            <label id="grounded-filter__label" class="custom-control-label ms-2"
                   for="grounded-filter"
            >{{ searchFilterTranslations().titleGrounded }}</label
            >
          </div>
          <div class="custom-control custom-radio mb-3">
            <input
              class="custom-control-input"
              id="not-grounded-filter"
              [name]="isMobile ? 'grounded-filter-mobile' : 'grounded-filter'"
              type="radio"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Not Grounded"
              [checked]="isGroundedFilterChecked(groundedFilters.NOT_GROUNDED)"
              (change)="setGroundedFilter(groundedFilters.NOT_GROUNDED)"
              aria-labelledby="not-grounded-filter__label"
              [attr.aria-checked]="isGroundedFilterChecked(groundedFilters.NOT_GROUNDED)"
            />
            <label id="not-grounded-filter__label" class="custom-control-label ms-2"
                   for="not-grounded-filter"
            >{{ searchFilterTranslations().titleNotGrounded }}</label>
          </div>
        </div>
      </app-search-filter-section>
    }
    @if (isReserveFilterEnabled) {
      <div
        class="sell-filter-section-header fw-bold">{{ searchFilterTranslations().labelReserveInformation }}
      </div>
      <div class="reserve-information-filter">
        <div class="custom-control mb-3">
          <div class="form-group mb-0">
            <label class="control-label text-uppercase fw-bold" for="avis-rep-select-dropdown"
                   data-test-id="app-search-filter-e-avis-rep-label">
              {{ searchFilterTranslations().labelAvisRep }}
            </label>
          </div>
          <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
            <app-dropdown-select
              id="avis-rep-select-dropdown"
              label="Avis Rep"
              [items]="reservedByUsersDropdown$()"
              (click)="selectReservedByUsersDropdown($event)"
              data-test-id="app-search-filter-e-avis-rep-select-dropdown">
            </app-dropdown-select>
          </trap-focus>
        </div>
        <div class="custom-control mb-3">
          <div class="form-group mb-0">
            <label class="control-label text-uppercase fw-bold" for="dealership-select-dropdown"
                   data-test-id="app-search-filter-e-dealership-label">
              {{ searchFilterTranslations().labelDealership }}
            </label>
          </div>
          <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
            <app-dropdown-select
              id="dealership-select-dropdown"
              label="Dealership"
              [items]="dealershipDropdown$()"
              (click)="selectDealershipDropdown($event)"
              data-test-id="app-search-filter-e-dealership-select-dropdown">
            </app-dropdown-select>
          </trap-focus>
        </div>
      </div>
    }
  </div>
</ng-container>
